<!-- /**
 * @author Ketan Shetye
 * @created 2025-10-25
 */ -->
 <!-- added by priya 23-12-2025 -->
 @if (isImage) {
  <img
    [src]="data.imageSrc"
    class="image-style"
    alt="icon-image"
  />
}
 <!-- end by priya 23-12-2025 -->

@else {

  <!-- SVG ICON -->
  @if (isSvgIcon) {
    <mat-icon
      class="svg-icon-style"
      [svgIcon]="data.iconName">
    </mat-icon>
  }
  @else {
<!-- Code changed by Amisha for custom icon sets on 12-11-2025 -->
<mat-icon
      class="font-icon-style"
      [fontSet]="data.iconSet || 'material-icons'">
      {{ data.iconName }}
    </mat-icon>
  }
<!-- Code changed by Amisha for custom icon sets on 12-11-2025 -->

}
